import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const AUTH_TOKEN_COOKIE = "auth_token";

export type DecodedToken = {
  userId: string;
  email: string;
  roleId: string;
  exp?: number;
  iat?: number;
};

export const getToken = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return Cookies.get(AUTH_TOKEN_COOKIE) ?? null;
};

export const setToken = (token: string) => {
  Cookies.set(AUTH_TOKEN_COOKIE, token, {
    sameSite: "lax",
    secure: false,
    path: "/",
  });
};

export const clearToken = () => {
  Cookies.remove(AUTH_TOKEN_COOKIE, { path: "/" });
};

export const decodeToken = (token: string): DecodedToken | null => {
  try {
    return jwtDecode<DecodedToken>(token);
  } catch {
    return null;
  }
};
